"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const react_number_format_1 = __importDefault(require("react-number-format"));
const components_1 = require("@/common/components");
const string_utils_1 = require("@/common/string_utils");
function default_1({ diffCalcWrapperCss, index, control, minQuantity, minimumPriceRule, defaultQuantity, defaultPrice, onDifferentialQuantityBlur, onDifferentialPriceBlur, interposeText, disabled, isFeeFree, }) {
    const { field: { onChange: onQuantityChange, value: quantityValue }, } = (0, react_hook_form_1.useController)({
        name: `diff_quantity_${index}`,
        control,
        rules: { required: true, min: minQuantity },
        shouldUnregister: true,
        defaultValue: defaultQuantity,
    });
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: diffCalcWrapperCss }, { children: [(0, jsx_runtime_1.jsx)(react_number_format_1.default, { disabled: disabled, className: disabled ? 'surface-bg' : 'surface-white', css: {
                    width: '100%',
                    height: '40px',
                    padding: '0 13px',
                    border: '1px solid var(--gray-10)',
                    borderRadius: '8px',
                    fontSize: '15px',
                    color: 'var(--gray-80)',
                    ':focus': {
                        border: '1px solid var(--gray-80)',
                    },
                    ':disabled': {
                        backgroundColor: 'var(--surface-bg)',
                        WebkitTextFillColor: 'var(--gray-40)',
                        opacity: 1,
                    },
                }, allowNegative: false, isAllowed: ({ value }) => Number(value) <= 9999, decimalScale: 0, value: quantityValue, onValueChange: e => onQuantityChange(e.value), thousandSeparator: true, placeholder: "0", autoComplete: "off", pattern: "\\d*", onBlur: (e) => onDifferentialQuantityBlur((0, string_utils_1.numberOnly)(e.target.value)) }, `diff_quantity_${defaultQuantity}_${index}`), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: interposeText })), (0, jsx_runtime_1.jsx)(components_1.PriceCalculator, { name: `diff_price_${index}`, control: control, defaultValue: defaultPrice, onBlurFunc: onDifferentialPriceBlur, isFeeFree: isFeeFree, disabled: disabled, required: true, minimumRule: minimumPriceRule, isDelivery: true }, `diff_price_${defaultPrice}_${index}`)] })));
}
exports.default = default_1;
